const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

async function request(path, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API ${path} -> ${res.status}: ${text}`);
  }
  return res.json();
}

export const api = {
  health: () => request("/health"),
  katlasStatus: () => request("/katlas/status"),
  katlasDiagnostics: () => request("/katlas/diagnostics?probe=full"),
  listRequests: () => request("/requests"),
  summary: () => request("/requests/summary"),
  getRequest: (id) => request(`/requests/${id}`),
  submitReview: (id, payload) =>
    request(`/requests/${id}/review`, {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  getReceipt: (hash) => request(`/receipts/${hash}`),
  listReceipts: () => request("/receipts"),
  portfolio: () => request("/portfolio"),
};
